import { Component, OnInit, Inject } from '@angular/core';
import { FormGroupDirective, FormControl, NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RefundService } from 'src/app/services/refund.service';
import { Refund } from 'src/app/models/refund';
import { SnackBarIconService } from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-product-refund-dialog',
  templateUrl: './product-refund-dialog.component.html',
  styleUrls: ['./product-refund-dialog.component.scss']
})
export class ProductRefundDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;
  public isEdit: boolean;

  public spinner: boolean = false;

  constructor(
    public _refundService: RefundService,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    private snackBar: SnackBarIconService,
    @Inject(MAT_DIALOG_DATA) public data: Refund
    ) { }

  ngOnInit() {
    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
    } else {
      this.isEdit = false
    }
    
    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)  

  }


  insert() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Refund = this.createEntity(this.entityForm.value);

      this._refundService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert refund error: " + error)
          let msgError: string = this._refundService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Refund = this.createEntity(this.entityForm.value);

      this._refundService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("regional update error: " + JSON.stringify(error))
          let msgError: string = this._refundService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity(data: any): Refund {
    let entity = new Refund();
    entity.id = data.id;
    entity.product_id = data.product_id;
    entity.percent = data.percent;

    let dtTemp = new Date(data.date)
    dtTemp.setHours(23, 59, 59)
    entity.date = dtTemp;

    return entity;
  }

  setFormValues(data, form) {
  
    if(this.isEdit) 
    {
      form.controls.id.setValue(data.id);
      form.controls.product_id.setValue(data.product_id);
      form.controls.percent.setValue(data.percent);
  
      let dt: any = data.date
      form.controls.date.setValue(new Date(dt.seconds*1000));
    }
    else {
      form.controls.product_id.setValue(this.data.product_id);
    }

  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      product_id: new FormControl('', [Validators.required]),
      percent: new FormControl('', [Validators.required]),
      date: new FormControl('', [Validators.required])
    });
    return form
  }

}
